import { createReducer, on } from '@ngrx/store';
import { mapToggle, mapUpdate } from '../state/map-actions-creator';
import { initialMapState } from './map-state';

export const mapReducer = createReducer(
  initialMapState,
  on(mapToggle, (state, action) => ({...state, enabled: action.enabled})),
  on(mapUpdate, (state, action) => ({...state, ...action.payload})),
);

